"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._MembershipSelectionCustomReferences = void 0;
exports._MembershipSelectionCustomReferences = {
    termPaymentFrequency: {
        dataTag: 'get',
        uid: 'termPaymentFrequency',
        legacy: '',
        description: 'Gives the payment frequency of the given term. For example "pro MONAT", or "4 WOCHEN"',
        required: false,
    },
    subDescription: {
        dataTag: 'get',
        uid: 'subDescription',
        legacy: '',
        description: 'Creates a subdescription for the given term, using an element with data-ref="subdescription" as based for each entry, if it exists.',
        required: false,
    },
    interval: {
        dataTag: 'get',
        uid: 'interval',
        legacy: '',
        description: 'Gives the the duration of a given term. For example "1 MONAT", or "12 MONATE"',
        required: false,
    },
    name: {
        dataTag: 'get',
        uid: 'name',
        legacy: '',
        description: 'Gives the name of the given membership',
        required: false,
    },
    price: {
        dataTag: 'get',
        uid: 'price',
        legacy: '',
        description: 'Gives the price of the given membership. Converted by currency.',
        required: false,
    },
    currency: {
        dataTag: 'get',
        uid: 'currency',
        legacy: '',
        description: 'Gives the currency used for the payments of a given membership',
        required: false,
    },
    term: {
        dataTag: 'term',
        uid: '[magicline name]',
        legacy: '',
        description: 'Can be used to access any magicline term attribute, check <a href="https://vamos-ab-city.api.magicline.com/connect/v1/rate-bundle?studioId=1210006110">vamos memberships</a> under "terms" as example.',
        required: false,
    },
};
